import type {
  CodeEnum,
  SiteEnum,
  TypeEnum,
  ApplicantStatusEnum,
  MethodEnum,
  CareerEnum,
  TryoutCouponTypeEnum,
  ReportTypeEnum,
  SurveyStatusEnum,
  OrganizationPaymentMethodEnum,
  OrganizationPaymentStatusEnum,
  StatusEnum,
  ReceiptStatusEnum,
  OrganizationTypeEnum,
  LocaleEnum,
  ClientAppServiceEnum,
} from '@zelos/codegen/apis';

// 현재는 이름만 있으나, 다른 정보가 필요할 시 추가/변경 가능
// best는 서버에서 해당 정보를 가져오는것

// api 제네레이터에서 enum모델이 만들어지지 않아 직접 추가
export type RemarksEnum = 'AB' | 'AC' | 'CH' | 'VI';

type ClassificationMeta = {
  title: string,
  levels: number[],
  baseFee: number,
};

export const classificationMeta: { [key in CodeEnum]: ClassificationMeta } = {
  PCCP: {
    title: '코딩전문역량인증',
    levels: [1, 2, 3, 4, 5],
    baseFee: 50_000,
  },
  PCCE: {
    title: '코딩필수역량인증',
    levels: [1, 2, 3, 4],
    baseFee: 35_000,
  },
  PCSQL: {
    title: 'SQL역량인증',
    levels: [1, 2, 3, 4],
    baseFee: 50_000,
  },
};

export const classificationMetaKeys = Object.keys(classificationMeta) as Array<CodeEnum>;

export const tryoutType: { [key in TypeEnum]: string } = {
  RE: '정기 시험',
  OC: '수시 시험',
  SP: '특별 시험',
};

export const tryoutTypeShort: { [key in TypeEnum]: string } = {
  RE: '정기',
  OC: '수시',
  SP: '특별',
};

export const tryoutSite: { [key in SiteEnum]: string } = {
  MO: '온라인',
  OF: '오프라인',
};

export const applicantStatus: { [key in ApplicantStatusEnum]: string } = {
  RE: '접수 완료',
  CA: '접수 취소',
  DO: '응시 완료',
  NT: '미응시',
};

export const receiptStatus: { [key in ReceiptStatusEnum]: string } = {
  CO: '접수 완료',
  CA: '접수 취소',
  EN: '시험 종료',
  WA: '승인 대기',
};

export const paymentMethod: { [key in MethodEnum | OrganizationPaymentMethodEnum]: string } = {
  CR: '신용/체크카드',
  BA: '실시간 계좌이체',
  MO: '휴대폰 결제',
  KA: '카카오페이',
  OR: '단체 접수',
  TB: '세금계산서 발행',
};

export const jobCareer: { [key in CareerEnum]: string } = {
  JR: '신입',
  SR: '경력',
};

export const couponType: { [key in TryoutCouponTypeEnum]: string } = {
  PRS: '비공개',
  PUS: '공개',
  USE: '사용자 지정',
};

export const reportType: { [key in ReportTypeEnum]: string } = {
  PR: '시험 대리 응시',
  FO: '신분증 위/변조',
  CO: '시험 문제 촬영 및 기록 등 저작권 침해',
  EL: '통신기기를 이용한 조직적 부정행위',
};

export const remarkType: { [key in RemarksEnum]: string } = {
  AB: '결시',
  AC: '사고/사유',
  CH: '부정행위',
  VI: '규정위반',
};

export const surveyStautsType: { [key in SurveyStatusEnum]: string } = {
  RE: '진행 예정',
  PR: '진행 중',
  DO: '진행 종료',
};

export const paymentState: { [key in StatusEnum | OrganizationPaymentStatusEnum]: string } = {
  paid: '결제 완료',
  failed: '결제 실패',
  ready: '결제 대기',
  cancelled: '결제 취소',
  not_found: '정보 없음',
  approved: '승인 완료',
  WFA: '승인 대기',
};

export const organizationType: { [key in OrganizationTypeEnum]: string } = {
  ER: '임직원 접수',
  OR: '단체 접수',
  ST: '특별 시험',
  NO: '단체 접수 아님',
};

export const languageLocales: { [key in LocaleEnum]: string } = {
  ko: '한국어',
  en: '영어',
};

export const clientAppService: { [key in ClientAppServiceEnum]: string } = {
  RC: '인증서 조회',
};
